import * as React from 'react';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import {
    createStyles,
    Dialog,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import { LocationOnOutlined, EditOutlined } from '@material-ui/icons';
import { useState } from "react";
import { IServicioAdicional, ServicioAdicional as ServicioCotizacion } from "../../entities/catalogos/ServicioAdicional";
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NumberField from "../controls/NumberField";
import { ChangeEvent } from "react";
import { IEvent } from "../../interfaces/IEvent";
import { updateServicio } from "../../redux/actions/servicioAdicionalActions";
import { useSnackbar } from "notistack";
import TextField from "@material-ui/core/TextField";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { IDocumento } from "../../interfaces/IDocumento";
import { Defaults } from "../../defaults/Defaults";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import HelpServiciosAdicionales, { IHelp } from '../help/HelpServiciosAdicionales';
import ConfirmDialog from "../controls/ConfirmDialog";
import { traducirButton, traducirLabel, traducirMessage } from '../../blocks/traductor';



const useStyles = makeStyles(() =>
    createStyles({
        iconCustomMaterial: {
            fontSize: 30
        },
        iconCustom: {
            width: "30px",
            height: "30px"
        },
        nameCard: {
            fontSize: "10px",
            padding: "0px 5px"
        },
        titleSelected: {
            color: "white",
            fontSize: "12px"
        },
        titleUnselected: {
            color: "black",
            fontSize: "11px"
        },
        inputCantidad: {
            fontSize: "11px",
            height: "8px",
            "&::placeholder": {
                opacity: 1
            },
        }
    })
);

interface OwnProps {
    value: ServicioCotizacion
    onSelect: (servicio: IServicioAdicional) => void
    cotizacionId: number
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    documentosCliente: IDocumento[],
    ayuda: IHelp
}

interface DispatchProps {
    updateServicio: typeof updateServicio
}

type Props = OwnProps & StateProps & DispatchProps

const ServicioAdicional = (props: Props) => {
    const totalDocumentosCliente = props.documentosCliente != null ? props.documentosCliente.length : 0;
    const documentosInicio = props.value.documentos ? props.value.documentos : [...props.documentosCliente];
    const [servicio, setServicio] = useState<ServicioCotizacion>(props.value);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [cambioEnDocumentos, setCambioEnDocumentos] = useState<boolean>(false);
    const [mostrarConfirm, setMostrarConfirm] = useState<boolean>(false);
    const [documentos, setDocumentos] = useState<IDocumento[]>(documentosInicio);
    const { enqueueSnackbar } = useSnackbar();
    const estiloSeleccionado = servicio.seleccionado ? 'selected' : '';
    const [headerAyuda, setHeaderAyuda] = useState("");
    const [descripcionAyuda, setDescripcionAyuda] = useState("");
    const estiloRequerido = servicio.esRequerido && !servicio.seleccionado ? 'required' : '';

    const classes = useStyles();
    const nombreIcono = servicio.configuracion.conceptoIcono ? servicio.configuracion.conceptoIcono.rutaIcono.split('.')[0] : null;
    const nombreIconoDisplay = servicio.seleccionado ? `${nombreIcono}_seleccionado.png` : `${nombreIcono}.png`;

    React.useEffect(() => {
        if (props.solicitud.tipoDocumento !== undefined) {
            localStorage.setItem("tipoDocumento", props.solicitud.tipoDocumento.toString());
        }
    }, [props.solicitud.tipoDocumento]);

    React.useEffect(() => {

        let etiquetas = JSON.parse(localStorage.getItem("etiquetas") ?? "");
        let servicioId = servicio?.id ?? 0;
        let number = "000" + servicioId.toString();
        number = number.substr(number.length - 3);
        let claveEtiqueta = "lbl_servicio_adicional_" + number;
        if (etiquetas.length) {
            let etiqueta = etiquetas.find(a => a.clave == claveEtiqueta);
            if (etiqueta !== undefined) {
                if(localStorage.getItem("idioma")==='en-US'){
                    setHeaderAyuda((servicio.etiquetaServicioAdicionalDto.nombre === null || servicio.etiquetaServicioAdicionalDto.nombre === '') ? servicio.nombre : servicio.etiquetaServicioAdicionalDto.nombre);
                }
                else{
                    setHeaderAyuda(servicio.nombre);    
                }
                setDescripcionAyuda(etiqueta.descripcion)
            }
        }


        if ((servicio.nombre == "RETORNO DOCUMENTOS" || servicio.concepto?.nombreConcepto == "RETORNO DOCUMENTOS") && !!totalDocumentosCliente) {
            const copiaServicio = new ServicioCotizacion({ ...servicio, esRequerido: true, cantidad: documentosInicio.length });
            setServicio(copiaServicio);
            props.onSelect(copiaServicio);
        }

        if ((servicio.nombre == "RETORNO DOCUMENTOS" || servicio.concepto?.nombreConcepto == "RETORNO DOCUMENTOS") && servicio.seleccionado && !servicio.esRequerido && totalDocumentosCliente == 0) {
            const copiaServicioR = new ServicioCotizacion({ ...servicio, cantidad: servicio.documentos?.length });
            setServicio(copiaServicioR);
            props.onSelect(copiaServicioR);
        }

        if (servicio.nombre == "A.P.C.") {
            const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
            setServicio(copiaServicio);
        }

        if (servicio.nombre == "CARGO POR CITA RAD" && props.solicitud.fechaCitaRad) {
            let citafueraHorario = props.solicitud.EsRadCitaFueraHorario!==undefined ? props.solicitud.EsRadCitaFueraHorario : false;
            if(!citafueraHorario){
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }
        if (servicio.nombre == "CARGO POR CITA EAD" && props.solicitud.fechaCitaEad) {
            let citafueraHorario = props.solicitud.EsEadCitaFueraHorario!==undefined ? props.solicitud.EsEadCitaFueraHorario : false;
            if(!citafueraHorario){
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }

        if (servicio.nombre == "CARGO POR CITA RAD CEDIS" && props.solicitud.fechaCitaRadCedis) {
            let citafueraHorario = props.solicitud.EsRadCitaFueraHorario!==undefined ? props.solicitud.EsRadCitaFueraHorario : false;
            if(!citafueraHorario){
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }
        if (servicio.nombre == "CARGO POR CITA EAD CEDIS" && props.solicitud.fechaCitaEadCedis) {
            let citafueraHorario = props.solicitud.EsEadCitaFueraHorario!==undefined ? props.solicitud.EsEadCitaFueraHorario : false;
            if(!citafueraHorario){
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }

        props.solicitud?.serviciosAdicionales?.forEach(s => {
            if (!servicio.esRetornoDocumentos && servicio.esCantidad && s.cantidad && s.cantidad > 0 && s.id == servicio.id) {
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                copiaServicio.cantidad = s.cantidad;
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }

            if (servicio.seleccionDirecta && s.id == servicio.id) {
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        });

        if (props.solicitud.horariosOrigen !== undefined && props.solicitud.horariosOrigen.length && props.solicitud.horariosDestino != undefined &&
            props.solicitud.horariosDestino.length && ((servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO' && props.solicitud.EsEadCitaFueraHorario!==undefined )|| (servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitud.EsRadCitaFueraHorario!==undefined))) {

            let diaSemana = -1;
            let horaCita = new Date();
            let horaEntrada = new Date();
            let horaSalida = new Date();
            let horario = [];
            let citaFecha;
            if (servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO' && props.solicitud.fechaCitaEad !== undefined && props.solicitud.fechaCitaEad !== null) {
                diaSemana = new Date(props.solicitud.fechaCitaEad).getDay();
                horaCita = new Date(new Date(props.solicitud.fechaCitaEad).getFullYear(), new Date(props.solicitud.fechaCitaEad).getMonth(), new Date(props.solicitud.fechaCitaEad).getDate(), new Date(props.solicitud.fechaCitaEad).getHours(), new Date(props.solicitud.fechaCitaEad).getMinutes(), new Date(props.solicitud.fechaCitaEad).getSeconds());
                let hourMinute = props.solicitud.EadCitaHoraDe !== undefined ? props.solicitud.EadCitaHoraDe.split(":") : "00:00".split(":");
                horaCita.setHours(parseInt(hourMinute[0]));
                horaCita.setMinutes(parseInt(hourMinute[1]));
                citaFecha = horaCita;
                
            } else if (servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitudCopia.fechaCitaRad !== undefined && props.solicitudCopia.fechaCitaRad !== null) {
                diaSemana = new Date(props.solicitudCopia.fechaCitaRad).getDay();
                horaCita = new Date(new Date(props.solicitudCopia.fechaCitaRad).getFullYear(), new Date(props.solicitudCopia.fechaCitaRad).getMonth(), new Date(props.solicitudCopia.fechaCitaRad).getDate(), new Date(props.solicitudCopia.fechaCitaRad).getHours(), new Date(props.solicitudCopia.fechaCitaRad).getMinutes(), new Date(props.solicitudCopia.fechaCitaRad).getSeconds());
                let hourMinute = props.solicitudCopia.RadCitaHoraDe !== undefined ? props.solicitudCopia.RadCitaHoraDe.split(":") : "00:00".split(":");
                horaCita.setHours(parseInt(hourMinute[0]));
                horaCita.setMinutes(parseInt(hourMinute[1]));
                citaFecha = new Date(new Date(props.solicitudCopia.fechaCitaRad).getFullYear(), new Date(props.solicitudCopia.fechaCitaRad).getMonth(), new Date(props.solicitudCopia.fechaCitaRad).getDate());
           }

            if (diaSemana < 6 && diaSemana !== 0 && diaSemana !== -1) {// L-V
                horario = servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' ? props.solicitud.horariosOrigen[0] : props.solicitud.horariosDestino[0];
                horaEntrada = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                horaSalida = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                if (horaCita > horaSalida || horaCita < horaEntrada) {

                    const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                    setServicio(copiaServicio);
                    props.onSelect(copiaServicio);
                }

            } else if (diaSemana === 6) {//Sabado
                horario = servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' ? props.solicitud.horariosOrigen[1] : props.solicitud.horariosDestino[1];
                horaEntrada = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                horaSalida = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                
                if (horaCita > horaSalida || horaCita < horaEntrada) {

                    const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                    setServicio(copiaServicio);
                    props.onSelect(copiaServicio);
                }
            } else if (diaSemana === 0) {//domingo
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }
        if((props.solicitud.areaServicioDestinoId == undefined || props.solicitud.areaServicioOrigenId == undefined || props.solicitud.areaServicioDestinoId == 0  || props.solicitud.areaServicioOrigenId == 0) && ((servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO' && props.solicitud.EsEadCitaFueraHorario!==undefined )|| (servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitud.EsRadCitaFueraHorario!==undefined))){
            let diaSemana = -1;
            let horaCita = new Date();
            let horaEntrada = new Date();
            let horaSalida = new Date();
            let horario = [];
            let citaFecha;
            
            if (servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO' && props.solicitud.fechaCitaEad !== undefined && props.solicitud.fechaCitaEad !== null) {
                diaSemana = new Date(props.solicitud.fechaCitaEad).getDay();
                horaCita = new Date(new Date(props.solicitud.fechaCitaEad).getFullYear(), new Date(props.solicitud.fechaCitaEad).getMonth(), new Date(props.solicitud.fechaCitaEad).getDate(), new Date(props.solicitud.fechaCitaEad).getHours(), new Date(props.solicitud.fechaCitaEad).getMinutes(), new Date(props.solicitud.fechaCitaEad).getSeconds());
                let hourMinute = props.solicitud.EadCitaHoraDe !== undefined ? props.solicitud.EadCitaHoraDe.split(":") : "00:00".split(":");
                horaCita.setHours(parseInt(hourMinute[0]));
                horaCita.setMinutes(parseInt(hourMinute[1]));
                citaFecha = horaCita;
                
            } else if (servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitudCopia.fechaCitaRad !== undefined && props.solicitudCopia.fechaCitaRad !== null) {
                diaSemana = new Date(props.solicitudCopia.fechaCitaRad).getDay();
                horaCita = new Date(new Date(props.solicitudCopia.fechaCitaRad).getFullYear(), new Date(props.solicitudCopia.fechaCitaRad).getMonth(), new Date(props.solicitudCopia.fechaCitaRad).getDate(), new Date(props.solicitudCopia.fechaCitaRad).getHours(), new Date(props.solicitudCopia.fechaCitaRad).getMinutes(), new Date(props.solicitudCopia.fechaCitaRad).getSeconds());
                let hourMinute = props.solicitudCopia.RadCitaHoraDe !== undefined ? props.solicitudCopia.RadCitaHoraDe.split(":") : "00:00".split(":");
                horaCita.setHours(parseInt(hourMinute[0]));
                horaCita.setMinutes(parseInt(hourMinute[1]));
                citaFecha = new Date(new Date(props.solicitudCopia.fechaCitaRad).getFullYear(), new Date(props.solicitudCopia.fechaCitaRad).getMonth(), new Date(props.solicitudCopia.fechaCitaRad).getDate());
           }

           if (diaSemana < 6 && diaSemana !== 0 && diaSemana !== -1) {
            if(servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO'){
                horario = props.solicitud.horariosDestino[0];
                horaEntrada = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                horaSalida = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                if (horaCita > horaSalida || horaCita < horaEntrada) {

                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
                }
            }
            if(servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitud.horariosOrigen !== undefined){
                horario = props.solicitud.horariosOrigen[0];
                horaEntrada = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                horaSalida = new Date(citaFecha.getFullYear(), citaFecha.getMonth(),citaFecha.getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                if (horaCita > horaSalida || horaCita < horaEntrada) {

                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
                }
            }
            } else if (diaSemana === 6)
            {
                if(servicio.nombre === 'FLETE CARGO EAD FUERA DE HORARIO')
                {
                    horario = props.solicitud.horariosDestino[1];
                    horaEntrada = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                    horaSalida = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                
                    if (horaCita > horaSalida || horaCita < horaEntrada) 
                    {
                    const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                    setServicio(copiaServicio);
                    props.onSelect(copiaServicio);  
                    }
                    }
                    if(servicio.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && props.solicitud.horariosOrigen !== undefined)
                    {
                    horario = props.solicitud.horariosOrigen[1];
                    horaEntrada = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaEntrada']).getHours(), new Date(horario['horaEntrada']).getMinutes(), new Date(horario['horaEntrada']).getSeconds());
                    horaSalida = new Date(new Date(horario['horaEntrada']).getFullYear(), new Date(horario['horaEntrada']).getMonth(), new Date(horario['horaEntrada']).getDate(), new Date(horario['horaSalida']).getHours(), new Date(horario['horaSalida']).getMinutes(), new Date(horario['horaSalida']).getSeconds());
                    
                    if (horaCita > horaSalida || horaCita < horaEntrada) 
                    {
                    const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                    setServicio(copiaServicio);
                    props.onSelect(copiaServicio);     
                    }
                }
            } else if (diaSemana === 0) {
                const copiaServicio = new ServicioCotizacion({ ...servicio, seleccionado: true });
                setServicio(copiaServicio);
                props.onSelect(copiaServicio);
            }
        }
    }, [localStorage.getItem("idioma")]);

    const quitarDialog = () => {
        const totalDocumentos = documentosInicio.length;

        if ((cambioEnDocumentos || documentos.length != totalDocumentos) && !mostrarConfirm) {
            setMostrarConfirm(true);
            return;
        }

        const cantidad = totalDocumentos == 0 ? undefined : totalDocumentos;
        const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad });
        setServicio(copiaServicio);
        props.onSelect(copiaServicio);

        setDocumentos(documentosInicio);
        setDialogOpen(false);
        setMostrarConfirm(false);
    }

    const editarRetornoDocumento = () => {
        abrirDialog();
    }

    const abrirDialog = () => {
        const copiaServicio = new ServicioCotizacion(servicio);
        setServicio(copiaServicio);
        //setDialogOpen(true);
        //setCambioEnDocumentos(false);
        const tipoDocumento = props.solicitud.tipoDocumento ?? Number(localStorage.getItem("tipoDocumento"));
        //if (props.solicitud.tipoDocumento != 1) {
        if (tipoDocumento != 1){
            setDialogOpen(true);
            setCambioEnDocumentos(false);
        }
        else {

            let nuevosDocumntos: IDocumento[] = [];
            //nuevoDocumento.documento="";
            const documentosExistentes = documentos.length ?? 0;
            if (documentosExistentes != 0) {
                for (let i = 0; i < documentosInicio.length; i++) {
                    const existeDocumento = i < documentosExistentes;
                    const nuevoDocumento: IDocumento = {
                        id: i + 1,
                        clienteDocumentoID: existeDocumento ? documentos[i].clienteDocumentoID : 0,
                        documento: existeDocumento ? documentos[i].documento : "",
                        descripcion: existeDocumento ? documentos[i].descripcion : traducirLabel(4)//"ADICIONAL"
                    };

                    nuevosDocumntos.push(nuevoDocumento);
                }
            }
            else {
                const nuevoDocumento: IDocumento = {
                    id: 1,
                    clienteDocumentoID: 0,
                    documento: "",
                    descripcion: traducirLabel(4)//"ADICIONAL"
                };
                nuevosDocumntos.push(nuevoDocumento);
            }


            setDocumentos(nuevosDocumntos);
            setCambioEnDocumentos(true);
            const copiaDocumentos = nuevosDocumntos;
            const copiaServicio = new ServicioCotizacion({ ...servicio, documentos: copiaDocumentos });
            copiaServicio.Seleccionar(true, false);
            setDialogOpen(false);
            setServicio(copiaServicio);
            props.onSelect(copiaServicio);
        }
    };

    const cerrarDialog = (copiaServicio: ServicioCotizacion) => {
        if (copiaServicio.esFormaValida) {
            setDialogOpen(false);
            setServicio(copiaServicio);
            props.onSelect(copiaServicio);
        } else
            enqueueSnackbar(traducirMessage(131), //"Favor de seleccionar una opción de origen o destino.", 
                { variant: "error" });
    };

    const seleccionarDesdeDialog = () => {
        const copiaDocumentos = servicio.esRetornoDocumentos ? documentos : [];
        const copiaServicio = new ServicioCotizacion({ ...servicio, documentos: copiaDocumentos });
        if (servicio.esRetornoDocumentos && Number(servicio.cantidad) > 0) {
            copiaServicio.Seleccionar(true, false);
        } else if (!servicio.esRetornoDocumentos) {
            copiaServicio.Seleccionar(true, false);
        }

        cerrarDialog(copiaServicio);
    };

    const handleCantidad = (event: ChangeEvent<HTMLInputElement> | IEvent) => {
        let value = (event.target.value || event.target.value == 0) ? Number(event.target.value) : null;
        value = totalDocumentosCliente > Number(value) ? totalDocumentosCliente : value;

        const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad: value });
        setServicio(copiaServicio);


    };

    const seleccionarServicio = () => {
        const copiaServicio = new ServicioCotizacion({ ...servicio });
        const eraSeleccionado = servicio.seleccionado;

        if (servicio.esRetornoDocumentos && !eraSeleccionado) {
            abrirDialog();
            return;
        }

        if (eraSeleccionado || copiaServicio.SeleccionarPorClick()) {
            if (eraSeleccionado) {
                copiaServicio.Deseleccionar(props.documentosCliente);
                setDocumentos(props.documentosCliente);
            }

            setServicio(copiaServicio);
            props.onSelect(copiaServicio);
        } else {
            enqueueSnackbar(traducirMessage(105), //"Favor de marcar el origen, el destino, o ambos"
                { variant: "error" });
        }
    }

    const onChangeServicio = (propiedad: string, esCheck: boolean = false) => ({ target }) => {
        const value = esCheck ? target.checked : target.value;

        const copiaServicio = new ServicioCotizacion({ ...servicio, [propiedad]: value });

        if (propiedad !== "costo")
            copiaServicio.CambiarValores();

        setServicio(copiaServicio);
        props.onSelect(copiaServicio);
    };

    const addDocumento = () => {
        const nuevoDocumento: IDocumento = {
            id: 0,
            clienteDocumentoID: 0,
            documento: "",
            descripcion: traducirLabel(4)//"ADICIONAL"
        };
        nuevoDocumento.id = (documentos.length === 0 ? 1 : Math.max(...documentos.map(d => d.id))) + 1;

        setDocumentos([...documentos, nuevoDocumento]);

        const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad: documentos.length + 1 });
        setServicio(copiaServicio);
    };

    const deleteDocumento = (id: number) => {
        const copiaDocumentos = documentos.filter(m => m.id !== id);
        setDocumentos(copiaDocumentos);
        const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad: documentos.length - 1 });
        setServicio(copiaServicio);
    };

    const updateDocumento = (event: ChangeEvent<HTMLInputElement> | IEvent, documento: IDocumento) => {
        const name = event.target.name || "";
        let value: any = event.target.value;
        const copiaDocumento = { ...documento, [name]: value };
        setDocumentos(documentos.map(d => d.id !== documento.id ? d : copiaDocumento));
        setCambioEnDocumentos(true);
    };

    const agregarRetornos = (event) => {
        if (!event.target.value) return;

        let nuevosDocumntos: IDocumento[] = [];
        const documentosExistentes = documentos.length ?? 0;

        let value = Number(event.target.value);

        value = totalDocumentosCliente > Number(value) ? totalDocumentosCliente : value;
        const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad: value });
        setServicio(copiaServicio);

        let total = totalDocumentosCliente > value ? totalDocumentosCliente : value;

        if (total > 20) {
            total = 20;
            const copiaServicio = new ServicioCotizacion({ ...servicio, cantidad: 20 });
            setServicio(copiaServicio);
        }

        for (let i = 0; i < total; i++) {
            const existeDocumento = i < documentosExistentes;
            const nuevoDocumento: IDocumento = {
                id: i + 1,
                clienteDocumentoID: existeDocumento ? documentos[i].clienteDocumentoID : 0,
                documento: existeDocumento ? documentos[i].documento : "",
                descripcion: existeDocumento ? documentos[i].descripcion : traducirLabel(4)//"ADICIONAL"
            };

            nuevosDocumntos.push(nuevoDocumento);
        }
        setDocumentos(nuevosDocumntos);
    }

    const getGridSize = (): 4 | 6 => {
        return servicio.mostrarCheckDestino && servicio.mostrarCantidadDestino && servicio.esAbierto ? 4 : 6;
    }

    if(servicio.configuracion?.esCotizacionSeccionOrigenDestino !== undefined && servicio.configuracion?.esCotizacionSeccionOrigenDestino !== null){
        if(!servicio.configuracion?.esCotizacionSeccionOrigenDestino){
            if (props.solicitud.paisIdDestino>0 && props.solicitud.paisIdDestino>0){
                if(servicio.mostrarCheckOrigen !== undefined && servicio.mostrarCheckDestino !== undefined){
                    if (!servicio.mostrarCheckOrigen && !servicio.mostrarCheckDestino) {
                        return null;
                    }
                }else if((props.value.aplicaOrigen !== undefined && !props.value.aplicaOrigen) && (props.value.aplicaDestino !== undefined && !props.value.aplicaDestino)){
                    return null;
                }

            }
        }
    }else{
        if(!props.value.configuracion?.esCotizacionSeccionOrigenDestino){
            if (props.solicitud.paisIdDestino>0 && props.solicitud.paisIdDestino>0){
                if(props.value.mostrarCheckOrigen !== undefined && props.value.mostrarCheckDestino !== undefined){
                    if (!props.value.mostrarCheckOrigen && !props.value.mostrarCheckDestino) {
                        return null;
                    }
                }else if((props.value.aplicaOrigen !== undefined && !props.value.aplicaOrigen) && (props.value.aplicaDestino !== undefined && !props.value.aplicaDestino)){
                    return null;
                }

            }
            if((props.value.aplicaOrigen !== undefined && !props.value.aplicaOrigen) && (props.value.aplicaDestino !== undefined && !props.value.aplicaDestino)){
                return null;
            }
        }
    }

    return (<>
        <Grid item style={{ position: "relative" }}>
            <Box display="flex" className={`card small-height ${estiloSeleccionado} ${estiloRequerido}`}
                justifyContent="center" style={{ width: "187px", height: "170px" }}>
                <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" pt={1}>
                    <Box style={{ width: "150px", textAlign: "center" }}>
                        <Box onClick={seleccionarServicio} pb={1} style={{ cursor: "pointer" }}>
                            {servicio.configuracion.conceptoIcono ?
                                <img src={"/image/iconosSitioExterno/" + nombreIconoDisplay} alt="icon"
                                    className={classes.iconCustom} />
                                :
                                <LocationOnOutlined className={classes.iconCustomMaterial} />
                            }

                            <Box className={classes.nameCard + " title-4 text-center"}>
                                {localStorage.getItem("idioma") === 'en-US' &&
                                    <b>{(servicio.etiquetaServicioAdicionalDto === undefined || servicio.etiquetaServicioAdicionalDto.nombre === null || servicio.etiquetaServicioAdicionalDto.nombre === '') ?
                                        (servicio.concepto === undefined || servicio.concepto === null) ? servicio.nombre : servicio.concepto?.etiquetaConcepto.nombreConcepto :
                                        servicio.etiquetaServicioAdicionalDto.nombre}</b>
                                }
                                {localStorage.getItem("idioma") !== 'en-US' &&
                                    <b>{(servicio.nombre === undefined || servicio.nombre === null || servicio.nombre === '') ? servicio.concepto?.nombreConcepto : servicio.nombre}</b>
                                }
                            </Box>
                        </Box>

                        {!servicio.abrirDialog &&
                            <Grid container spacing={1}
                                style={{ justifyContent: servicio.esSeccionOrigenDestino ? 'center' : '' }}>
                                <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}>
                                    {servicio.mostrarCheckOrigen &&
                                        <FormControlLabel label={traducirLabel(222)}
                                            control={
                                                <Checkbox checked={servicio.aplicaOrigen ?? false}
                                                    onChange={onChangeServicio("aplicaOrigen", true)}
                                                    color="primary" size="small" />
                                            } />
                                    }
                                </Grid>

                                <Grid item xs={6}>
                                    {servicio.mostrarCantidadOrigen &&
                                        <TextField
                                            placeholder={traducirLabel(29)}
                                            value={servicio.cantidadOrigen}
                                            disabled={!servicio.aplicaOrigen}
                                            onChange={onChangeServicio("cantidadOrigen")}
                                            InputProps={{
                                                classes: { input: classes.inputCantidad },
                                                inputComponent: NumberField as any,
                                                inputProps: { precision: 0, maxLength: 3 },
                                            }}
                                        />
                                    }
                                </Grid>

                                {servicio.mostrarCheckDestino &&
                                    <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}>
                                        <FormControlLabel label={traducirLabel(86)} /*"Destino"*/
                                            control={
                                                <Checkbox checked={servicio.aplicaDestino ?? false}
                                                    onChange={onChangeServicio("aplicaDestino", true)}
                                                    disabled={servicio.destinoSeleccionado}
                                                    color="primary" size="small" />
                                            } />

                                    </Grid>
                                }

                                {!servicio.mostrarCheckDestino &&
                                    <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}></Grid>
                                }

                                <Grid item xs={6}>
                                    {servicio.mostrarCantidadDestino &&
                                        <TextField
                                            placeholder={traducirLabel(29)}
                                            value={servicio.cantidadDestino}
                                            disabled={!servicio.aplicaDestino}
                                            onChange={onChangeServicio("cantidadDestino")}
                                            InputProps={{
                                                classes: { input: classes.inputCantidad },
                                                inputComponent: NumberField as any,
                                                inputProps: { precision: 0, maxLength: 3 },
                                            }}
                                        />
                                    }
                                </Grid>
                                <Grid item xs={6} className="chk-xs" style={{ textAlign: 'start' }}></Grid>
                                {servicio.esAbierto &&
                                    <Grid item xs={6}>
                                        <TextField
                                            placeholder={traducirLabel(56)}
                                            value={servicio.costo}
                                            onChange={onChangeServicio("costo")}
                                            disabled={!servicio.seleccionado}
                                            InputProps={{
                                                classes: { input: classes.inputCantidad },
                                                inputComponent: NumberField as any,
                                                inputProps: { prefix: '$', precision: 2, maxLength: 10 },
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        }
                    </Box>
                </Box>
            </Box>

            {<div style={{ position: "absolute", top: "10px", left: "10px" }}>
                {servicio.esRetornoDocumentos && servicio.seleccionado && (props.solicitud.tipoDocumento != 1) &&
                    <IconButton size="small" style={{ color: "white" }} onClick={editarRetornoDocumento}>
                        <EditOutlined />
                    </IconButton>
                }
            </div>}

            <div style={{ position: "absolute", top: "10px", right: "20px" }}>
                {servicio.esSeccionServiciosAdicionales && (!servicio.esOrigen && !servicio.esDestino) &&
                    <div className={`title-4 ${servicio.seleccionado ? 'white-label' : ''}`}>
                        {""}
                    </div>
                }
            </div>

            {!servicio.seleccionado &&
                <HelpServiciosAdicionales comments={descripcionAyuda} ayuda={headerAyuda} customStyle={{ bottom: "80px", right: "-5px" }}
                    size="small" />}
            {servicio.seleccionado && <HelpServiciosAdicionales comments={descripcionAyuda} ayuda={headerAyuda}
                customStyle={{ bottom: "80px", right: "-5px", color: "#FFF" }} size="small" />}
        </Grid>


        <Dialog open={dialogOpen} maxWidth="sm" fullWidth={true}>
            {localStorage.getItem("idioma") === 'en-US' &&
                <DialogTitle id="simple-dialog-title">{servicio.etiquetaServicioAdicionalDto.nombre}</DialogTitle>
            }
            {localStorage.getItem("idioma") !== 'en-US' &&
                <DialogTitle id="simple-dialog-title">{servicio.nombre}</DialogTitle>
            }
            <ValidatorForm onSubmit={seleccionarDesdeDialog}>
                <DialogContent dividers>
                    <Box display="flex" mb={2}>
                        <Box mr={4}>
                            {servicio.esRetornoDocumentos &&
                                <TextValidator
                                    label={traducirLabel(29)}
                                    value={servicio.cantidad}
                                    name="cantidad"
                                    onChange={handleCantidad}
                                    onBlur={agregarRetornos}
                                    validators={['required']}
                                    errorMessages={[traducirLabel(126)]}
                                    disabled={true}
                                    InputProps={{
                                        inputComponent: NumberField,
                                        inputProps: { precision: 0, maxLength: 2 },
                                    }}
                                />
                            }
                        </Box>
                    </Box>

                    <TableContainer>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ width: "45%" }}>
                                        {/* Documento */traducirLabel(102)}
                                    </TableCell>
                                    <TableCell align="center" style={{ width: "45%" }}>
                                        {/* Descripción */traducirLabel(81)}
                                    </TableCell>
                                    <TableCell align="center" style={{ padding: 0, width: "10%" }}>
                                        <AddCircleIcon color="primary" style={{ fontSize: "1rem" }}
                                            className="pointer" onClick={addDocumento} />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {documentos?.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <TextValidator
                                                value={row.documento}
                                                name="documento"
                                                onChange={(e) => updateDocumento(e, row)}

                                                validators={['required']}
                                                errorMessages={[""]}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <TextField value={row.descripcion} fullWidth disabled
                                                name="descripcion" />
                                        </TableCell>

                                        <TableCell style={{ padding: "0 5px 0 0" }}>
                                            {row.clienteDocumentoID === 0 &&
                                                <DeleteIcon color="error" style={{ fontSize: "1rem" }} className="pointer"
                                                    onClick={() => deleteDocumento(row.id)} />
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>

                <DialogActions>
                    <Button type="submit" variant="contained" color="primary">
                        {/* Guardar */traducirButton(12)}
                    </Button>
                    <Button onClick={quitarDialog} variant="contained">
                        {/* Cerrar */traducirButton(16)}
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>

        {mostrarConfirm &&
            <ConfirmDialog titulo={traducirLabel(32)} contenido={traducirMessage(165)}
                abierto={mostrarConfirm} confirmar={quitarDialog}
                cerrar={() => setMostrarConfirm(false)} />
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    documentosCliente: state.cliente.documentos,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    updateServicio: updateServicio
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicioAdicional);
